import { ChangeDetectionStrategy, Component, input, resource } from '@angular/core';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { MarkdownViewerComponent } from '@modules/common/components/markdown-viewer/markdown-viewer.component';
import { PreviewErrorComponent } from '../preview-error/preview-error.component';

const MAX_TEXT_PREVIEW_BYTES = 5 * 1024 * 1024;

@Component({
  selector: 'app-text-preview',
  templateUrl: './text-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LoadingIndicatorComponent, MarkdownViewerComponent, PreviewErrorComponent],
  host: { class: 'block w-full h-full' },
})
export class TextPreviewComponent {
  public readonly blob = input<Blob | null>(null);
  public readonly renderAsMarkdown = input(false);

  protected readonly text = resource<string, Blob | null>({
    params: () => this.blob(),
    defaultValue: '',
    loader: async ({ params: blob }) => {
      if (!blob) {
        return '';
      }
      if (blob.size > MAX_TEXT_PREVIEW_BYTES) {
        throw new Error('File is too large to preview. Please download it.');
      }
      return blob.text();
    },
  });
}
